// import './NewsList.less';
import './NewNewsList.less';
import '../../pages/MenuListPage/MenuListPage.less';

export const prefix = 'bm-c-news-list';

export { default } from './NewsList';
